import { render, staticRenderFns } from "./CDCReport.vue?vue&type=template&id=22f06ce4&scoped=true&"
import script from "./CDCReport.vue?vue&type=script&lang=js&"
export * from "./CDCReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f06ce4",
  null
  
)

export default component.exports